import Joi from "joi";
import { Relationship } from "../../../graphql/generated";

// TTMSD-1566: Shipper, Commodity and Receiver are mandatory when creating a
// relation — each must have at least one entry. Supplier and Customer stay
// optional (empty means "any supplier" / "all customers", as the form hints).
const requiredSelection = (label: string) =>
  Joi.array().items(Joi.string()).min(1).required().label(label).messages({
    "any.required": `${label} is required`,
    "array.min": `${label} is required`,
  });

const driverShiftSchema = Joi.object<Relationship>({
  supplierIds: Joi.array().items(Joi.string()).label("Supplier"),
  shipperIds: requiredSelection("Shipper"),
  commodityIds: requiredSelection("Commodity"),
  receiverIds: requiredSelection("Receiver"),
  customerIds: Joi.array().items(Joi.string()).label("Customer"),
});

export default driverShiftSchema;
